import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import { SessionExpiryHandler } from '../common/SessionExpiryHandler';
import { AuthRouter } from './AuthRouter';
import { DashboardRoutes } from './DashboardRoutes';
import { RequireAuth } from './RequireAuth';

export const AppRouter = () => {
  return (
    <BrowserRouter>
      <SessionExpiryHandler />
      <Routes>
        <Route path="/account/*" element={<AuthRouter />} />
        <Route
          path="/*"
          element={
            <RequireAuth>
              <DashboardRoutes />
            </RequireAuth>
          }
        />
      </Routes>
    </BrowserRouter>
  );
};
